// extracted by mini-css-extract-plugin
module.exports = {"number":"NotificationIconUI_number__3iU63","bigNumber":"NotificationIconUI_bigNumber__3jfD9"};